import type { Violation } from '@finn-no/mobility-item-insertion-shared';
import type { FieldErrors } from 'react-hook-form';

const flattenErrors = (errors: Record<string, any>, parent = ''): Record<string, string> => {
  const result: Record<string, string> = {};

  for (const [key, value] of Object.entries(errors)) {
    if (typeof value === 'object' && Object.hasOwn(value, 'message')) {
      result[parent + key] = value.message;
    } else if (typeof value === 'object' && value !== null) {
      const nestedErrors = flattenErrors(value, `${key}.`);
      for (const [nestedKey, nestedValue] of Object.entries(nestedErrors)) {
        result[nestedKey] = nestedValue;
      }
    }
  }

  return result;
};

const getOrderedFields = (widgets: any[], prefix = ''): string[] =>
  widgets.flatMap((widget) => {
    const fieldName = prefix ? `${prefix}.${widget.name}` : widget.name;
    if (widget.type === 'group' && 'children' in widget && widget.children) {
      return getOrderedFields(widget.children, fieldName);
    }
    return fieldName;
  });

export const getSortedErrorFields = (
  formErrors: FieldErrors,
  widgetModel: any[],
  currentStepFields?: Set<string>,
  remoteViolations: Violation[] = [],
): string[] => {
  const flattenedErrors = flattenErrors(formErrors);
  const clientErrorFields = Object.keys(flattenedErrors).filter((field) => !/\d\.description$/.test(field));

  const orderedFields = getOrderedFields(widgetModel);

  const serverErrorFields = currentStepFields
    ? remoteViolations.filter((violation) => currentStepFields.has(violation.field)).map((violation) => violation.field)
    : [];

  const allErrorFields = [...clientErrorFields, ...serverErrorFields];
  const sortedErrorFields = [...new Set(allErrorFields)].sort(
    (a, b) => orderedFields.indexOf(a) - orderedFields.indexOf(b),
  );

  return sortedErrorFields;
};
